import React, { useState } from "react";
import { sampleNotificationData } from "../../assets/staticData";
import NotificationItem from "../../components/NotificationItem";
import { useDispatch, useSelector } from "react-redux";
import { setNotifications } from "../../redux/reducers/common";
import { ClickAwayListener } from "@mui/material";
import { updateReadNotification } from "../../api/common";
import { useTranslation } from "react-i18next";

const NotificationPopup = (props: any) => {
  const { isOpen, handleClose } = props;
  const [t] = useTranslation();
  const dispatch = useDispatch();
  // const [notifications] = useState(sampleNotificationData);
  const notifications = useSelector((state: any) => state.common.notifications);
  const unreadCount = notifications?.filter((n: any) => !n.isRead).length;

  const manageOnClick = (readNotification: any) => {
    const updatedNotifications = notifications.map((n: any) =>
      n.id === readNotification.id ? readNotification : n
    );
    dispatch(setNotifications(updatedNotifications));
    updateReadNotification({ notificationId: readNotification?.id, isRead: readNotification?.isRead });
  };

  const manageAllRead = () => {
    const noReadList = notifications?.filter((n: any) => !n.isRead);
    noReadList?.map((item:any) => {
      updateReadNotification({ notificationId: item?.id, isRead: true });
    });
    const notReadIds = noReadList?.map((d:any) => d.id);
    const updatedList = notifications?.map((d:any) => notReadIds?.includes(d?.id) ? {...d, isRead: true} : d);
    dispatch(setNotifications(updatedList));
  }

  return (
    <div style={{ position: "relative", display: "inline-block" }}>
      {isOpen && (
        // <ClickAwayListener onClickAway={handleClose}>
          <>
            <div
              onClick={handleClose}
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                zIndex: 999,
              }}
            />
            <div
              style={{
                position: "absolute",
                top: "45px",
                right: "36px",
                marginTop: "16px",
                width: "420px",
                maxHeight: "600px",
                backgroundColor: "white",
                borderRadius: "12px",
                boxShadow: "0 8px 24px rgba(0,0,0,0.12)",
                zIndex: 1000,
                overflow: "hidden",
              }}
            >
              {/* Tooltip Arrow */}
              <div
                style={{
                  position: "absolute",
                  top: "-8px",
                  right: "12px",
                  width: "16px",
                  height: "16px",
                  backgroundColor: "white",
                  transform: "rotate(45deg)",
                  boxShadow: "-2px -2px 4px rgba(0,0,0,0.05)",
                }}
              />
              <div
                style={{
                  padding: "20px",
                  borderBottom: "1px solid #e0e0e0",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <h2
                  style={{
                    margin: 0,
                    fontSize: "20px",
                    fontWeight: 600,
                    color: "#2c3e50",
                  }}
                >
                  Notifications
                </h2>
                {unreadCount > 0 && (
                <button
                  className="read-toggle-btn"
                  onClick={manageAllRead}
                  style={{
                    padding: '4px 12px',
                    fontSize: '11px',
                    fontWeight: 600,
                    color:  '#1976d2',
                    backgroundColor: '#e3f2fd',
                    border: '1px solid #1976d2',
                    borderRadius: '12px',
                    cursor: 'pointer',
                    transition: 'all 0.2s',
                    whiteSpace: 'nowrap',
                    height: '20px',
                    marginTop: 'auto'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor =  '#bbdefb';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor =  '#e3f2fd';
                  }}
                >
                  {t('MARK_ALL_AS_READ')}
                </button>
                )}
              </div>

              <div
                style={{
                  maxHeight: "500px",
                  overflowY: "auto",
                }}
              >
                {notifications.length > 0 ? (
                  notifications.map((notification: any) => (
                    <NotificationItem
                      key={notification.id}
                      notification={notification}
                      onClose={manageOnClick}
                    />
                  ))
                ) : (
                  <div
                    style={{
                      padding: "40px",
                      textAlign: "center",
                      color: "#999",
                    }}
                  >
                    No notifications yet
                  </div>
                )}
              </div>
            </div>
          </>
        // </ClickAwayListener>
      )}
    </div>
  );
};

export default NotificationPopup;
